import * as React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";

const MetricComparisonCards = ({
  data,
  metrics,
  selectedMetrics,
  colors,
  chartType,
}) => {
  const calculateTotal = (metric) => {
    if (chartType === "trend") {
      // For trend data, sum up all values for the metric
      return data.reduce((sum, item) => sum + (item[metric] || 0), 0);
    } else {
      // For breakdown data, sum up values from all categories in the selected breakdown
      const breakdownData = Object.values(data).flat();
      return breakdownData.reduce((sum, item) => sum + (item[metric] || 0), 0);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
      {selectedMetrics.map((metric, index) => {
        const total = calculateTotal(metric);
        const metricInfo = metrics.find((m) => m.value === metric);
        const unit = metricInfo?.unit === "€" ? "€" : "";

        return (
          <Card key={metric} className="flex flex-col">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <div
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: colors[index] }}
                />
                {metricInfo?.label || metric}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-bold">
                {unit === "€"
                  ? `${unit} ${total.toLocaleString()}`
                  : total.toLocaleString()}
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default MetricComparisonCards;
